module.exports = __webpack_public_path__ + "img/interview2.d20ac949.png";